import { useTranslation } from 'react-i18next';
import EditProjectModal from './EditProjectModal';
import { useProjectConfigState } from '../hooks/useProjectConfigState';

type ConfigState = ReturnType<typeof useProjectConfigState>;

interface EditProjectDialogProps {
  cfg: ConfigState;
  open: boolean;
  onClose: () => void;
  /** 是否已开始分析（原 ProjectDetail 传 !!analysis）。*/
  analysisStarted: boolean;
}

/**
 * 自包含「项目设置」弹窗：渲染现有 EditProjectModal。
 * 配置态由父级持有的 useProjectConfigState(cfg) 提供，行为与迁移前一致：
 * - 保存走 cfg.save('project')（原 handleSaveProject()）。
 * - 派生 props（scriptSkillName、enableScriptNormalization）按原 ProjectDetail 口径计算。
 * - 关闭（取消）时 resetFromProject() 丢弃未保存改动，与 StyleConfigDialog 对齐；
 *   否则残留编辑态会在下次任意保存时被原样发出（语种字段现按原始值直传）。
 */
export default function EditProjectDialog({ cfg, open, onClose, analysisStarted }: EditProjectDialogProps) {
  const { t } = useTranslation('projectDetail');
  return (
    <EditProjectModal
      {...cfg}
      open={open}
      t={t}
      analysisStarted={analysisStarted}
      enableScriptNormalization={cfg.editEnableScriptNormalization}
      scriptSkillName={cfg.bootstrap.scriptSkills.find(s => s.id === cfg.editScriptSkillId)?.name || ''}
      skills={cfg.bootstrap.skills}
      langSkills={cfg.langSkills}
      langSkillsLoading={cfg.langSkillsLoading}
      languages={cfg.bootstrap.languages}
      voicePresets={cfg.bootstrap.voicePresets}
      onClose={() => { cfg.resetFromProject(); onClose(); }}
      onSave={async () => { if (await cfg.save('project')) onClose(); }}
    />
  );
}
